import React from "react";
import "./ReferenceCard.css";
import ReactMarkdown from "react-markdown";

interface ReferenceCardProps {
  id: string;
  title: string;
  description: string;
  badge?: string;
}

const ReferenceCard: React.FC<ReferenceCardProps> = ({
  id,
  title,
  description,
  badge,
}) => {
  return (
    <div className="reference-card" id={id}>
      <div>
        <p className="reference-card-title">{title}</p>
        <ReactMarkdown
          className="reference-card-description"
          components={{
            a: ({ href, children }) => (
              <a href={href} target="_blank">
                {children}
              </a>
            ),
          }}
        >
          {description}
        </ReactMarkdown>
      </div>
      {badge && <span className="reference-card-badge">{badge}</span>}
    </div>
  );
};

export default ReferenceCard;
